module.exports = __webpack_public_path__ + "img/6_143.06bfb581.png";